import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import { useGlobalContext } from '../../context';
import CardWithFilter from '../../componenents/heroImage';

function Hero() {

  const {t} = useTranslation()
  const {initial, final, animation1, animation2} = useGlobalContext();

  return (
    <section className="section hero">
        <div className="container hero__container">
            <div className="hero__text_container">
                
                <motion.h1 
                  initial={initial}
                  animate={final}
                  transition={animation1}
                className='hero__title'>{t("hero.h1")}</motion.h1>
                <motion.h2 
                initial={initial}
                animate={final}
                transition={animation2}
                className="hero__subtitle">{t("hero.h2")}</motion.h2>
            </div>
            <CardWithFilter/>
              {/*<img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1701721170/hero_image_ubtybl_1_cxcogl.png" alt="hand holding a light lamp" />*/}             
        </div>
    </section>
  )
}

export default Hero;